import {
    type MutationAccountsCollectiblesHideArgs,
    type MutationAccountsCollectiblesShowArgs,
} from '@pkg/graphql/codegen/graphql';
import { collectiblesHide, collectiblesShow } from '@pkg/graphql/mutations';

import { graphqlMutation } from '@app/client/ApiFactory';

export function callHideCollectibles(params: { variables: MutationAccountsCollectiblesHideArgs }) {
    return graphqlMutation({
        ...params,
        query: collectiblesHide,
        apiSettingsType: 'marketplace',
    });
}

export function callShowCollectibles(params: { variables: MutationAccountsCollectiblesShowArgs }) {
    return graphqlMutation({
        ...params,
        query: collectiblesShow,
        apiSettingsType: 'marketplace',
    });
}
